import Toggle from "../../../Toggle";
import { Button } from "@oc-labs/wt-storybook";
import useMethodSystem from "../../useMethodSystem";

export default function DefaultOperatorSettings({ operator, onDelete, onToggleMethod }) {
  const { availableOperators, currencies } = useMethodSystem();
  const operatorInfo = availableOperators.find(op => op.id === operator.operatorId);
  const currencyInfo = currencies.find(c => c.id === operator.currencyId);

  return (
    <div
      className="bg-card rounded-lg border border-border transition-all duration-200 shadow-sm"
    >
      {/* Operator Header */}
      <div className="p-4 border-b border-border flex items-center justify-between">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            {operatorInfo?.logo && (
              <img
                src={operatorInfo?.logo || "/placeholder.svg"}
                alt={operatorInfo?.name}
                className="w-8 h-8 rounded"
              />
            )}
            <div>
              <div className="flex items-center gap-2">
                <h4 className="font-medium text-foreground">
                  {operatorInfo?.name}
                </h4>
                {currencyInfo && (
                  <span className="px-2 py-0.5 text-xs font-medium bg-primary/10 text-primary rounded">
                    {currencyInfo.name}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="">
          <Button
            type="danger"
            size="small"
            onClick={() => onDelete(operator.operatorId, operator.currencyId)}
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </Button>
        </div>
      </div>

      {/* Payment Methods */}
      <div className="p-4 bg-muted/50">
        <div className="space-y-3">
          {/* Card Payment */}
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <div className="w-5 h-5 bg-blue-100 dark:bg-blue-900/30 rounded flex items-center justify-center">
                <svg
                  className="w-3 h-3 text-blue-600 dark:text-blue-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4zM2 10v4a2 2 0 002 2h12a2 2 0 002-2v-4H2z" />
                </svg>
              </div>
              <span className="text-sm text-foreground">Card Payment</span>
            </div>

            <Toggle
              checked={operator.paymentMethods.card}
              onChange={() => onToggleMethod(operator.operatorId, operator.currencyId, "card")}
              text="Toggle card payment"
            />
          </div>

          {/* Bank Transfer */}
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <div className="w-5 h-5 bg-green-100 dark:bg-green-900/30 rounded flex items-center justify-center">
                <svg
                  className="w-3 h-3 text-green-600 dark:text-green-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zm0 2h12v8H4V6z"
                    clipRule="evenodd"
                  />
                  <path d="M5 8h10v1H5V8zm0 2h10v1H5v-1z" />
                </svg>
              </div>
              <span className="text-sm text-foreground">Bank Transfer</span>
            </div>

            <Toggle
              checked={operator.paymentMethods.bankTransfer}
              onChange={() => onToggleMethod(operator.operatorId, operator.currencyId, "bankTransfer")}
              text="Toggle bank transfer"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
